import * as constants from '../constants';

const INITIAL_STATE = {
    data: {},
};

export default function(state = INITIAL_STATE, action) {
    switch (action.type) {
        case constants.AUTH_LOGOUT:
        case constants.AUTH_LOGIN_SUCCESS:
            return INITIAL_STATE;

        case constants.DASHBOARD_REQUESTED:
        case constants.DASHBOARD_SUCCESS:
            return Object.assign({}, state, {data: {}});

        case constants.ANALYTICS_REQUESTED:
        case constants.ANALYTICS_LOADING:
            return Object.assign({}, state, {data: Object.assign({}, state.data, {
                [action.payload.id]: {loading: true, data: null},
            })});
        case constants.ANALYTICS_SUCCESS:
            return Object.assign({}, state, {data: Object.assign({}, state.data, {
                [action.payload.id]: {loading: false, data: action.payload.data, error: null},
            })});
        case constants.ANALYTICS_FAILURE:
            return Object.assign({}, state, {data: Object.assign({}, state.data, {
                [action.payload.id]: {loading: false, data: null, error: action.payload.error},
            })});
    }
    return state;
}
